<template>
  <div>
    <div v-if="!initialized">
      <span>読み込み中...</span>
    </div>
    <div class="d-flex flex-wrap gap-2" v-else>
      <template v-for="template in service.templates" :key="template.id">
        <AgreementTemplateSelectListItem :template="template" />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import AgreementTemplateSelectListItem from './AgreementTemplateSelectListItem.vue'
import { AgreementTemplateSelectService } from './AgreementTemplateSelectService'

export default {
  name: 'AgreementTemplateSelectList',
  components: { AgreementTemplateSelectListItem },
  data() {
    return {
      service: new AgreementTemplateSelectService(),
      initialized: false,
    }
  },
  async mounted() {
    await this.service.initPromise
    this.initialized = true
  },
}
</script>
